module.exports = __webpack_public_path__ + "img/gem-found-black.c014e1b8.png";